export const getCoralCommentsCountUpdate = () => {
  let result;
  if (result) return Promise.resolve(result);
  return import('./coral-requests').then((module) => {
    result = module;
    return module;
  });
};